import React, { useState } from 'react';
import axios from 'axios';
import Header from './Header';
import Footer from './Footer';
import './AdminUpload.css';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5001/lb-api';

const AdminUpload = ({ user }) => {
  const [excelFile, setExcelFile] = useState(null);
  const [audioFiles, setAudioFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState('');

  const handleUpload = async () => {
    if (!excelFile) { setError('Please select an Excel file'); return; }
    setUploading(true);
    setError('');
    setResult(null);

    const formData = new FormData();
    formData.append('excel', excelFile);
    for (const file of audioFiles) {
      formData.append('audio', file);
    }

    try {
      const res = await axios.post(`${API_BASE}/pre-assessment/upload`, formData, {
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' },
        timeout: 120000
      });
      setResult(res.data);
    } catch (err) {
      setError(err.response?.data?.error || err.message);
    }
    setUploading(false);
  };

  return (
    <div className="admin-upload-page">
      <Header user={user} />
      <main className="admin-upload-main">
        <h1>Pre-Assessment Questions Upload</h1>
        <p className="admin-upload-desc">Upload an Excel file with questions and optional audio files for listening sections.</p>

        <div className="admin-upload-section">
          <h3>Excel File (Required)</h3>
          <p className="admin-upload-hint">Columns: Language_Code, Level_Code, Section, Q#, Question, Option_A, Option_B, Option_C, Option_D, Audio_File, Audio_Text, Question_Type, Points</p>
          <input type="file" accept=".xlsx,.xls,.csv" onChange={e => setExcelFile(e.target.files[0])} />
        </div>

        <div className="admin-upload-section">
          <h3>Audio Files (Optional)</h3>
          <p className="admin-upload-hint">Select all audio files referenced in the Excel. They will be saved to /public/audio/</p>
          <input type="file" accept="audio/*" multiple onChange={e => setAudioFiles(Array.from(e.target.files))} />
          {audioFiles.length > 0 && <span className="admin-upload-count">{audioFiles.length} files selected</span>}
        </div>

        <button className="admin-upload-btn" onClick={handleUpload} disabled={uploading || !excelFile}>
          {uploading ? 'Uploading...' : 'Upload Questions'}
        </button>

        {error && <div className="admin-upload-error">{error}</div>}
        {result && (
          <div className="admin-upload-result">
            <h3>Upload Complete</h3>
            <p>Inserted: <strong>{result.inserted}</strong> questions</p>
            <p>Skipped: <strong>{result.skipped}</strong></p>
            <p>Audio files uploaded: <strong>{result.audioFilesUploaded}</strong></p>
            {result.errors && result.errors.length > 0 && (
              <div className="admin-upload-errors">
                <h4>Errors:</h4>
                {result.errors.map((e, i) => <p key={i}>{e}</p>)}
              </div>
            )}
          </div>
        )}
      </main>
      <Footer />
    </div>
  );
};

export default AdminUpload;
